interface DriverMonitoringWarningProps {
  totalCount: number;
}

const DriverMonitoringWarning = ({
  totalCount,
}: DriverMonitoringWarningProps) => {
  return (
    <div className='bg-yellow-50 border border-yellow-200 rounded-lg p-3'>
      <p className='text-sm text-yellow-800'>
        <strong>Nota:</strong> Se están mostrando los primeros 4 de {totalCount}{' '}
        conductores activos. Por ahora, solo se pueden visualizar hasta 4
        conductores simultáneamente.
      </p>
    </div>
  );
};

export default DriverMonitoringWarning;
